//src/context/PriceVisibilityContext.js
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getPriceVisibility } from "../services/priceVisibility.api";

const PriceVisibilityContext = createContext({
  pricesSalesVisible: true,
  loadingPriceVisibility: true,
  refreshPriceVisibility: () => {},
});

export const PriceVisibilityProvider = ({ children }) => {
  const [pricesSalesVisible, setPricesSalesVisible] = useState(true);
  const [loadingPriceVisibility, setLoadingPriceVisibility] = useState(true);

  const refreshPriceVisibility = useCallback(async () => {
    try {
      const res = await getPriceVisibility();
      setPricesSalesVisible(res?.pricesSalesVisible !== false);
    } catch {
      // Safe fallback: keep existing behavior if API fails
      setPricesSalesVisible(true);
    } finally {
      setLoadingPriceVisibility(false);
    }
  }, []);

  useEffect(() => {
    refreshPriceVisibility();

    const handler = () => refreshPriceVisibility();
    window.addEventListener("price-visibility-changed", handler);

    return () => {
      window.removeEventListener("price-visibility-changed", handler);
    };
  }, [refreshPriceVisibility]);

  return (
    <PriceVisibilityContext.Provider
      value={{
        pricesSalesVisible,
        loadingPriceVisibility,
        refreshPriceVisibility,
      }}
    >
      {children}
    </PriceVisibilityContext.Provider>
  );
};

export const usePriceVisibility = () => useContext(PriceVisibilityContext);
